(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider-advanced"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('.hero-slider__container');
      this.originalSlides = Array.from(this.querySelectorAll('.hero-slider__slide'));
      this.bullets = this.querySelectorAll('.hero-slider__bullet');
      
      this.isSingleSlide = this.originalSlides.length < 2;

      this.isMouseDown = false;
      this.isDragging = false;
      this.isTransitioning = false;
      this.startX = 0;
      this.currentTranslate = 0;
      this.animationID = 0;
      this.dragThreshold = 10;
      this.currentIndex = 1;
      this.numOriginalSlides = this.originalSlides.length;

      this.autoAdvance = this.dataset.autoAdvance === 'true';
      this.advanceTiming = parseInt(this.dataset.advanceTiming, 10);
      this.advanceTimer = null;
      this.isPausedByObserver = false;
      
      this.videoEndCallback = () => this.goToSlide(this.currentIndex + 1);

      this.init();
    }

    init() {
      if (this.isSingleSlide) {
        this.slides = this.originalSlides;
        this.setupIntersectionObserver();
        this.handleMedia();
        return; // Stop execution for single slide
      }

      this.setupInfiniteScroll();
      this.slides = Array.from(this.container.children);
      this.updatePosition(false);
      this.updateBullets();
      this.handleMedia();
      this.bindEvents();
      this.setupIntersectionObserver();
    }
    
    setupInfiniteScroll() {
      const firstSlideClone = this.originalSlides[0].cloneNode(true);
      const lastSlideClone = this.originalSlides[this.numOriginalSlides - 1].cloneNode(true);
      
      this.container.appendChild(firstSlideClone);
      this.container.insertBefore(lastSlideClone, this.container.firstChild);
    }

    bindEvents() {
      this.container.addEventListener('mousedown', this.dragStart.bind(this));
      this.container.addEventListener('touchstart', this.dragStart.bind(this), { passive: true });

      window.addEventListener('mouseup', this.dragEnd.bind(this));
      window.addEventListener('mousemove', this.drag.bind(this));
      window.addEventListener('touchend', this.dragEnd.bind(this));
      window.addEventListener('touchcancel', this.dragEnd.bind(this));
      window.addEventListener('touchmove', this.drag.bind(this), { passive: true });

      this.bullets.forEach((bullet) => {
        bullet.addEventListener('click', (e) => {
          const targetIndex = parseInt(e.currentTarget.dataset.gotoSlide, 10) + 1;
          if (targetIndex === this.currentIndex || this.isTransitioning) return;
          this.goToSlide(targetIndex);
        });
      });
      
      this.container.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
      window.addEventListener('resize', () => { this.updatePosition(false) });
    }

    dragStart(event) {
      if (this.isTransitioning) return;
      this.isMouseDown = true;
      this.stopAutoAdvance();
      this.startX = this.getPositionX(event);
    }

    drag(event) {
      if (!this.isMouseDown) return;

      const currentPosition = this.getPositionX(event);
      const movedBy = currentPosition - this.startX;

      if (!this.isDragging && Math.abs(movedBy) > this.dragThreshold) {
        this.isDragging = true;
        this.container.classList.add('is-dragging');
        this.animationID = requestAnimationFrame(this.animation.bind(this));
      }

      if (this.isDragging) {
        const startTranslate = this.currentIndex * -this.offsetWidth;
        this.currentTranslate = startTranslate + movedBy;
      }
    }

    dragEnd() {
      this.isMouseDown = false;

      if (!this.isDragging) {
        this.startAutoAdvance();
        return;
      }

      this.isDragging = false;
      cancelAnimationFrame(this.animationID);
      this.container.classList.remove('is-dragging');
      
      const movedBy = this.currentTranslate - (this.currentIndex * -this.offsetWidth);

      if (movedBy < -50 && this.currentIndex < this.slides.length - 1) {
        this.goToSlide(this.currentIndex + 1);
      } else if (movedBy > 50 && this.currentIndex > 0) {
        this.goToSlide(this.currentIndex - 1);
      } else {
        this.goToSlide(this.currentIndex);
      }
    }

    getPositionX(event) {
      return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }

    animation() {
      this.setSliderPosition();
      if (this.isDragging) requestAnimationFrame(this.animation.bind(this));
    }

    setSliderPosition() {
      this.container.style.transform = `translateX(${this.currentTranslate}px)`;
    }

    goToSlide(index) {
      if (this.isTransitioning) return;
      this.stopAutoAdvance();
      this.isTransitioning = true;
      this.currentIndex = index;
      
      this.updatePosition();
      this.updateBullets();
      this.handleMedia();
    }
    
    handleTransitionEnd() {
      this.isTransitioning = false;
      let jumped = false;
      
      if (this.currentIndex === 0) {
        this.currentIndex = this.numOriginalSlides;
        this.updatePosition(false);
        jumped = true;
      } else if (this.currentIndex === this.slides.length - 1) {
        this.currentIndex = 1;
        this.updatePosition(false);
        jumped = true;
      }
      
      if (jumped) {
        this.handleMedia();
      }
      
      this.startAutoAdvance();
    }
    
    updatePosition(useTransition = true) {
      this.container.style.transition = useTransition ? '' : 'none';
      this.currentTranslate = this.currentIndex * -this.offsetWidth;
      this.setSliderPosition();
    }

    updateBullets() {
      let activeBulletIndex = this.currentIndex - 1;
      if (this.currentIndex === 0) {
        activeBulletIndex = this.numOriginalSlides - 1;
      } else if (this.currentIndex === this.slides.length - 1) {
        activeBulletIndex = 0;
      }
      this.bullets.forEach((bullet, i) => bullet.classList.toggle('is-active', i === activeBulletIndex));
    }
    
    async playVideo(video) {
      try {
        video.muted = true;
        await video.play();
      } catch (error) {}
    }
    
    handleMedia(isResume = false) {
      this.slides.forEach((slide, index) => {
        const videos = slide.querySelectorAll('video');
        videos.forEach(video => video.removeEventListener('ended', this.videoEndCallback));

        const isActive = this.isSingleSlide ? true : (index === this.currentIndex);

        if (isActive && !this.isPausedByObserver) { 
          if (slide.dataset.slideType === 'video' && videos.length > 0) {
            videos.forEach(video => {
              if (!isResume) {
                video.currentTime = 0;
              }
              this.playVideo(video);
              if (!this.isSingleSlide) {
                video.addEventListener('ended', this.videoEndCallback);
              }
            });
          }
        } else {
          videos.forEach(video => video.pause());
        }
      });
    }

    startAutoAdvance() {
      if (this.isSingleSlide || !this.autoAdvance || this.isPausedByObserver || this.isDragging) return;
      this.stopAutoAdvance();

      const currentSlide = this.slides[this.currentIndex];
      if (currentSlide && currentSlide.dataset.slideType === 'image') {
        this.advanceTimer = setTimeout(() => {
          this.goToSlide(this.currentIndex + 1);
        }, this.advanceTiming);
      }
    }

    stopAutoAdvance() {
      clearTimeout(this.advanceTimer);
      this.advanceTimer = null;
    }
    
    setupIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isPausedByObserver = false;
            this.startAutoAdvance();
            this.handleMedia(true);
          } else {
            this.isPausedByObserver = true;
            this.stopAutoAdvance();
            this.slides.forEach(slide => slide.querySelectorAll('video').forEach(v => v.pause()));

            this.isMouseDown = false;
            this.isTransitioning = false;

            if (this.isDragging) {
              this.isDragging = false;
              cancelAnimationFrame(this.animationID);
              this.container.classList.remove('is-dragging');
              
              // Silently snap back to the correct resting position.
              this.updatePosition(false); 
              this.updateBullets(); // [BULLET FIX] This was the missing call to sync the bullets.
            }
          }
        });
      }, { threshold: 0.1 });

      observer.observe(this);
    }


  }

  customElements.define('hero-slider-section', HeroSlider);

  } catch(e) { console.error(e); }
})();
})();
